import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Whether the agent panel is open.
 *
 * Lifted out of the rail because the rail is no longer the only thing that can
 * open it: the navigation rail owns the affordance now. The agent is not a
 * destination, so it sits with Feedback and the profile in the rail's tool
 * cluster rather than in the list of places you can go.
 *
 * Separate from agentFocusStore on purpose. Focus is ephemeral — it describes
 * the page you happen to be on and must never survive a reload. This is a
 * preference, and it should: someone who works with the agent open wants it
 * open again tomorrow.
 */
type AgentPanelStore = {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
};

export const useAgentPanelStore = create<AgentPanelStore>()(
  persist(
    (set) => ({
      open: false,
      setOpen: (open) => set({ open }),
      toggle: () => set((s) => ({ open: !s.open })),
    }),
    { name: "co:agent:panel" },
  ),
);
